module.exports = __webpack_public_path__ + "3c18433afdadc2231c3316418720d5ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/meta_2021_chart.png
// module id = 1693
// module chunks = 0